import { env } from '@bitstopco/bitstop-theme';

const testnetPrefix = env.isTestnet() ? 'testnet.' : '';
export const NONCE_V1_HOST = `https://${testnetPrefix}nonce.lol`;

export const DEFAULT_ERROR_MESSAGE = 'Something went wrong, try again later!';

export const TABLE_SHOWING_VALUES = [5, 10, 20, 25, 50, 100, 1000];

export const NOT_AVAILABLE = 'n/a';

export const BITSTOP_OPERATOR_ID = env.isTestnet()
  ? Number(import.meta.env.VITE_BITSTOP_OPERATOR_ID_TESTNET) || 0
  : Number(import.meta.env.VITE_BITSTOP_OPERATOR_ID_MAINNET) || 0;

export const AUTH0_LOGIN_PATH = '/auth/login-v2';

export const AUTH0_LOGOUT_PATH = '/auth/logout-v2';

export const SESSION_ID_TOKEN_KEY = 'user@sessionIdToken';

export const AUTH0_CLAIM_NAMESPACE = 'https://nonce.lol';

export const AUTH0_CONFIG = {
  domain: env.isTestnet()
    ? (import.meta.env.VITE_AUTH0_DOMAIN_TESTNET ?? '')
    : (import.meta.env.VITE_AUTH0_DOMAIN_MAINNET ?? ''),
  clientId: env.isTestnet()
    ? (import.meta.env.VITE_AUTH0_CLIENT_ID_TESTNET ?? '')
    : (import.meta.env.VITE_AUTH0_CLIENT_ID_MAINNET ?? ''),
  // Not split: the API identifier is the same in both tenants.
  audience: import.meta.env.VITE_AUTH0_AUDIENCE ?? '',
  scope: 'openid profile email offline_access',
};
